<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Anulación Trabajo</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formAnulacion" autocomplete="off">
            <mat-form-field class="full-width">
                <mat-label>Motivo </mat-label>

                <textarea
                    matInput
                    formControlName="motivo"
                    required
                    rows="3"
                    placeholder="Motivo de la anulación"
                ></textarea>
                <mat-hint
                    >{{ motivo.value?.length }} / {{ largoMaximo }}</mat-hint
                >

                <mat-error *ngIf="motivo.hasError('required')">
                    Debe ingresar el motivo de la anulación del trabajo
                </mat-error>
            </mat-form-field>
        </form>
        <mat-label>Evaluación </mat-label>
        <br />
        <br />
        <app-star-rating
            [seteable]="true"
            (evaluacionEvent)="setEvaluacion($event)"
        ></app-star-rating>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
            mat-raised-button
            color="accent"
            (click)="guardar()"
            [disabled]="!formAnulacion.valid"
        >
            Anular
        </button>
    </mat-dialog-actions>
</div>
